module.exports = __webpack_public_path__ + "img/52.e052e497.jpg";